<template lang="pug">
  .component-selectize-driver
    selectize(v-if="options", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Vehicle Brand")
</template>

<script>
  import Selectize from "../../../Selectize";
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";

  export default {
    name: "SelectizeVehicleBrand",
    extends: BaseSelectize,
    components: {Selectize},
    data() {

      return {
        searchableFields: ['id', 'name']
      }
    },
    created() {

      if (this.clientDrivers.length > 0) {
        this.options = this.clientDrivers
        return
      }
      KeplerBackofficeSdk.selects.vehicleBrands((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>B${item.id}</small></div> <div>${item.name}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div><small>B${item.id}</small></div> <div>${item.name}</div></div>`
      }
    },
    props: {
      clientDrivers: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeVehicleBrand.vue?e487cc3a